<template>
  <span class="spinner" :class="size" role="status" aria-label="Loading" />
</template>

<script setup lang="ts">
withDefaults(defineProps<{ size?: 'small' | 'medium' }>(), { size: 'small' });
</script>

<style scoped lang="scss">
.spinner {
  display: inline-block;
  flex: 0 0 auto;
  border-radius: var(--t-border-radius-half-rounded);
  // The transparent edge is what makes the rotation readable; a full ring looks static.
  border: 2px solid currentColor;
  border-top-color: transparent;
  opacity: 0.6;
  animation: spinnerRotation 0.6s linear infinite;
}

.spinner.small {
  width: 12px;
  height: 12px;
  border-width: 1.5px;
}

.spinner.medium {
  width: 16px;
  height: 16px;
}

@keyframes spinnerRotation {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 2s;
  }
}
</style>
